// src/pages/CommissionCalculator.js
import React, { useState } from 'react';
import { Typography } from "@material-tailwind/react";
import { 
  CalculatorIcon, 
  DocumentTextIcon
} from "@heroicons/react/24/outline";

// Import calculator components
import CalculatorHero from '../components/calculators/CalculatorHero';
import QuickFeeCheck from '../components/calculators/QuickFeeCheck';
import QuoteBuilder from '../components/calculators/QuoteBuilder';
import { CalculatorProvider } from '../components/calculators/CalculatorContext';

const CommissionCalculator = () => {
  const [activeCalculator, setActiveCalculator] = useState(null);

  const handleCalculatorSelect = (type) => {
    setActiveCalculator(type);
  };

  const handleBack = () => {
    setActiveCalculator(null);
  };

  const calculatorOptions = [
    {
      id: 'quickCheck',
      title: 'Quick Fee Check',
      description: 'Enter a selling price to instantly see your earnings after Boutee fees',
      icon: CalculatorIcon,
      gradient: 'from-purple-500 to-pink-500',
      features: [
        'Instant fee breakdown',
        'VAT calculation',
        'Commission tiers visualisation',
      ]
    },
    {
      id: 'buildQuote',
      title: 'Quote Builder',
      description: 'Calculate the perfect price to achieve your target profit after all costs',
      icon: DocumentTextIcon,
      gradient: 'from-blue-500 to-purple-500',
      features: [
        'Target profit setting',
        'Automatic markup calculation',
        'Customer-ready quotes'
      ]
    }
  ];

  return (
    <CalculatorProvider>
      <div className="min-h-screen" style={{ backgroundColor: 'var(--color-background)' }}>
        {/* 
          FIX: The padding classes (px-*, sm:px-*, lg:px-*, py-*) have been REMOVED from this div.
          This resolves the double padding issue.
        */}
        <div className="max-w-7xl mx-auto">
          {!activeCalculator ? (
            <CalculatorHero 
              options={calculatorOptions}
              onSelect={handleCalculatorSelect}
            />
          ) : (
            <div className="animate-fadeIn">
              {activeCalculator === 'quickCheck' && (
                <QuickFeeCheck onBack={handleBack} />
              )}
              {activeCalculator === 'buildQuote' && (
                <QuoteBuilder onBack={handleBack} />
              )}
            </div>
          )}
        </div>
      </div>
    </CalculatorProvider>
  );
};

export default CommissionCalculator;